import {
  CommunicationPushNotification,
  CommunicationUserSpecificPushNotifications,
} from '@lexian/api/notifications-api';
import {useEmailPushNotification} from '_/hooks/communication/useEmailPushNotification';

export function useCommunicationPushNotification(
  callback: () => void | Promise<void>
): void {
  useEmailPushNotification((notification) => {
    if (
      isCommunicationPushNotification(notification) &&
      notification.needsAttention
    ) {
      callback();
    }
  });
}

const isCommunicationPushNotification = (
  body: CommunicationUserSpecificPushNotifications
): body is CommunicationPushNotification =>
  body.pushNotificationType === 'CommunicationPushNotification';
